<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<div class="ded">
<p class="dedit">Dedicated to Lorraine Dally</p>
<p class="dedi"><em class="italic">Great princes’ favourites their fair leaves spread</em></p>
<p class="dedi"><em class="italic">But as the marigold at the sun’s eye;</em></p>
<p class="dedi"><em class="italic">And in themselves their pride lies buried,</em></p>
<p class="dedi"><em class="italic">For at a frown they in their glory die.</em></p>
<p class="dedi1">William Shakespeare, Sonnet 25 (lines 5-8).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM01.vue?31c1aee8